import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import { Box, Center, Flex, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Pagination from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../components/common/Loading';
import { IGetSurveyTemplates } from '../../../models/admin/Survey.model';
import SurveyService from '../../../services/admin/survey.service';
import Adminroutes from '../routes';
import TemplateItem from './templateItem';


const SurveyTemplates = ({props}:any) => {
    const navigate = useNavigate();
    const [hideView, sethideView] = useState(true);
    const [reducedObj, setReducedObj] = useState<any>();
    const [templateCodes, setTemplateCodes] = useState<any>([{}]);
    const [surveyTemplates, setSurveyTemplates] = useState<IGetSurveyTemplates | any>([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(7);
    
    useEffect(() => {
        SurveyService.getSurveyTemplates().then(
            (res) => {
                setSurveyTemplates(res.data)
                const results = res.data.reduce((arr:any, template:any) => {
                    arr.push(template.code)
                    return(arr.filter((item:any, index:number) => arr.indexOf(item) === index))
                }, []);
                const resultObj = res.data.reduce((acc:any, item:any) => {
                    const existing = acc[item.code] || [];
                    existing.push(item.survey_question_id);
                    acc[item.code] = existing
                    return acc;
                }, {})
                if(results){
                    setTemplateCodes(results);
                    setLoading(false);
                }
                if(resultObj){
                    setReducedObj(resultObj);
                }
            })
    }, []);
    
    const currentItems = templateCodes.slice(currentPage * perPage, (currentPage + 1) * perPage);
    
    const handlePageChange = (page:any) => {
        setCurrentPage(page.selected);
    }

  return (
      <>
          <Flex bg="white" fontSize="14px" height="65px" width="100hw" justifyContent="flex-end" alignItems="center" px="2rem" direction="row" gap="1rem">
              <Text as="button" onClick={()=>navigate(Adminroutes.Survey)} color="red">Exit</Text>
          </Flex>
          <Flex bg="#F9F8F8" pb="2rem" direction="column" width="100hw" height="screen" minHeight="90vh" justifyContent="center" alignItems="center">
                <VStack bg="white" height="fit-content" gap="1rem" width="60%" mt={50} mb={50} py="2rem" justifyContent="center" alignItems="center">
                  {
                    loading ? <Loading/> :
                    currentItems.length > 0 ?
                    currentItems?.map((each: any, index: number) => (
                        <TemplateItem key={index} each={each} reducedObj={reducedObj}/>   
                    ))
                    : <Center>
                        <VStack>
                        <Text fontSize="18px" fontWeight="700" lineHeight="2rem" mb="1rem">Oops!</Text>
                        <Text>No available templates, please create one</Text>
                        </VStack>
                    </Center>

                }
                {
                    currentItems && !loading ?
                    <Box pb="1rem">
                        <Pagination
                        breakLabel="..."
                        nextLabel={<ArrowRightIcon style={{ fontSize: 18}} />}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={5}
                        pageCount={Math.ceil(templateCodes.length / perPage)}
                        previousLabel={<ArrowLeftIcon style={{ fontSize: 18}} />}
                        containerClassName='pagination'
                        pageLinkClassName='page-num'
                        previousLinkClassName='page-num'
                        nextLinkClassName='page-num'
                        activeLinkClassName='active'
                        // renderOnZeroPageCount={null}
                        /> 
                    </Box> : ""
                }
                </VStack>
          </Flex>
      </>
  )
}

export default SurveyTemplates